import { pageOffset, resolvePage, type PageInfo } from '@myrewards/contracts';

/** One page of a list that is already in memory; a page past the end shows the last one. */
export function clientPage<T>(
  rows: readonly T[],
  page: number,
  size: number,
): { rows: T[]; page: PageInfo } {
  const info = resolvePage(rows.length, page, size);
  const start = pageOffset(info);
  return { rows: rows.slice(start, start + size), page: info };
}
